var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhy1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.818,
    height: 41.558,
    viewBox: "0 0 40.818 41.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-object-2946586",
    transform: "translate(-73.979 0.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M280.39,12.757a.574.574,0,0,1-.243-.081l-9.982-5.762a.46.46,0,0,1,0-.812L280.147.34a.517.517,0,0,1,.487,0L290.616,6.1a.46.46,0,0,1,0,.812l-9.982,5.8a.517.517,0,0,1-.244.04Zm-9.008-6.249,9.049,5.194,9.049-5.194-9.09-5.194Z",
    transform: "translate(-181.28)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059_-_Outline",
    "data-name": "Path 1059 - Outline",
    d: "M280.39,13.257a1.024,1.024,0,0,1-.468-.134l-.026-.014-9.972-5.756a.96.96,0,0,1,0-1.69l10-5.77a1.02,1.02,0,0,1,.935,0l.026.014,9.972,5.756a.96.96,0,0,1,0,1.69l-10,5.811a.994.994,0,0,1-.466.093Zm-8.006-6.75,8.046,4.619,8.043-4.617L280.391,1.89Z",
    transform: "translate(-181.28)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M280.39,97.823a.574.574,0,0,1-.243-.081l-9.982-5.762a.447.447,0,0,1-.243-.406V80.009a.487.487,0,0,1,.974,0V91.29l9.5,5.478,9.536-5.478V80.01a.487.487,0,0,1,.974,0V91.534a.447.447,0,0,1-.243.406l-10.023,5.8a.579.579,0,0,1-.244.081Z",
    transform: "translate(-181.28 -73.502)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060_-_Outline",
    "data-name": "Path 1060 - Outline",
    d: "M280.39,98.324H279.2l.343-.351-9.621-5.553a.946.946,0,0,1-.5-.845V80.009a.987.987,0,0,1,1.974,0V91l9,5.19L289.426,91V80.01a.987.987,0,0,1,1.974,0V91.534a.946.946,0,0,1-.5.845l-10.04,5.811A1.028,1.028,0,0,1,280.39,98.324Z",
    transform: "translate(-181.28 -73.502)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M408.168,167.685a.469.469,0,0,1-.487-.487v-7.669a.487.487,0,0,1,.974,0V167.2A.469.469,0,0,1,408.168,167.685Z",
    transform: "translate(-309.058 -147.259)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061_-_Outline",
    "data-name": "Path 1061 - Outline",
    d: "M408.168,168.185a.965.965,0,0,1-.987-.987v-7.669a.987.987,0,1,1,1.974,0V167.2a.968.968,0,0,1-.987.987Z",
    transform: "translate(-309.058 -147.259)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M186.384,358.278h-2.272a.487.487,0,1,1,0-.974h2.272a10.2,10.2,0,0,0,5.8-1.786l.69-.446a.911.911,0,0,0,.325-1.136c-.69-.649-1.745-.284-2.881.081-.162.04-.365.122-.528.162a7.731,7.731,0,0,1-5.113-.2.04.04,0,0,1-.04-.04c-5.234-3.287-10.145-3.652-13.837-1.055a.5.5,0,1,1-.568-.811c4.017-2.84,9.292-2.475,14.852,1.014a6.893,6.893,0,0,0,4.382.162c.162-.04.365-.122.528-.162,1.258-.406,2.719-.893,3.855.162l.081.081c.04.04.04.081.081.122a1.869,1.869,0,0,1-.609,2.475l-.69.446a11.277,11.277,0,0,1-6.33,1.907Z",
    transform: "translate(-88.613 -324.542)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062_-_Outline",
    "data-name": "Path 1062 - Outline",
    d: "M186.384,358.778h-2.272a.987.987,0,1,1,0-1.974h2.272a9.658,9.658,0,0,0,5.518-1.7l.013-.008.686-.444a.451.451,0,0,0,.183-.416.91.91,0,0,0-.568-.159,6.059,6.059,0,0,0-1.647.383l-.128.04c-.062.016-.146.043-.226.07s-.192.064-.287.089a8.23,8.23,0,0,1-5.389-.2h0a.541.541,0,0,1-.253-.154,15.315,15.315,0,0,0-7.981-2.633,8.883,8.883,0,0,0-5.2,1.613.958.958,0,0,1-.581.2.986.986,0,0,1-.81-.424.963.963,0,0,1-.181-.73.992.992,0,0,1,.423-.666,10.737,10.737,0,0,1,6.317-1.983,17.217,17.217,0,0,1,9.037,2.956l.014.005a6.447,6.447,0,0,0,2.223.4,6.127,6.127,0,0,0,1.782-.263l.024-.007c.062-.016.146-.043.226-.07s.189-.063.284-.087l.025-.008a7.656,7.656,0,0,1,2.3-.484,2.864,2.864,0,0,1,2.013.769l.013.013.081.081a.677.677,0,0,1,.117.157l.012.011.034.059a2.358,2.358,0,0,1-.77,3.142l-.687.444a11.723,11.723,0,0,1-5.787,1.962l.014.027Zm6.08-2.843-.175.118.145-.1.008-.005.69-.446a1.319,1.319,0,0,0,.175-.136,1.345,1.345,0,0,1-.153.119l-.006,0Z",
    transform: "translate(-88.613 -324.542)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M185.058,377.93a5.186,5.186,0,0,1-.771-.04c-8.927-.528-14.121-1.055-14.162-1.055a.489.489,0,0,1,.081-.974c.04,0,5.234.528,14.121,1.055a12.41,12.41,0,0,0,6.574-1.461l10.226-5.762a1.046,1.046,0,0,0,.528-1.014c-.04-.446-.243-.974-1.3-1.217a4.782,4.782,0,0,0-2.637.649l-.243.122-2.516,1.177a.49.49,0,0,1-.406-.893l2.8-1.258a5.752,5.752,0,0,1,3.246-.69,2.365,2.365,0,0,1,1.988,2.069,1.973,1.973,0,0,1-1.014,1.948l-10.145,5.762a14.093,14.093,0,0,1-6.371,1.583Z",
    transform: "translate(-88.301 -339.69)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063_-_Outline",
    "data-name": "Path 1063 - Outline",
    d: "M185.058,378.43a5.7,5.7,0,0,1-.82-.043c-7-.414-11.772-.829-14-1.04l-.135-.013h-.015l-.035,0a1.02,1.02,0,0,1-.876-1.023v-.035l0-.035a1.02,1.02,0,0,1,1.023-.876c.028,0,.028,0,.21.017,2.22.211,6.984.626,13.941,1.039.214.011.435.017.652.017a11.933,11.933,0,0,0,5.651-1.417l10.222-5.76a.549.549,0,0,0,.276-.529c-.02-.22-.053-.581-.914-.78l-.021-.005a.925.925,0,0,0-.246-.03,5.716,5.716,0,0,0-1.907.591l-.14.06-.242.121-2.511,1.174a.94.94,0,0,1-.417.1,1.017,1.017,0,0,1-.9-.568.992.992,0,0,1,.467-1.32l.019-.009,2.894-1.3a7.6,7.6,0,0,1,2.788-.756,3.04,3.04,0,0,1,.682.075l.018,0a2.9,2.9,0,0,1,2.355,2.5v.005a2.46,2.46,0,0,1-1.271,2.436l-10.158,5.769a14.628,14.628,0,0,1-6.571,1.637h-.027Zm15.473-7.828-9.392,5.292a12.7,12.7,0,0,1-2.027.875,14.412,14.412,0,0,0,2.08-.863Z",
    transform: "translate(-88.301 -339.69)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M80.647,336.133H74.966a.487.487,0,1,1,0-.974h5.681a.624.624,0,0,0,.609-.609V320.227a.624.624,0,0,0-.609-.609H74.966a.487.487,0,0,1,0-.974h5.681a1.584,1.584,0,0,1,1.583,1.583v14.324a1.559,1.559,0,0,1-1.582,1.583Z",
    transform: "translate(0 -295.296)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064_-_Outline",
    "data-name": "Path 1064 - Outline",
    d: "M80.647,336.633H74.966a.987.987,0,1,1,0-1.974h5.681a.127.127,0,0,0,.109-.109V320.227a.127.127,0,0,0-.109-.109H74.966a.987.987,0,0,1,0-1.974h5.681a2.085,2.085,0,0,1,2.083,2.083v14.324a2.059,2.059,0,0,1-2.082,2.083Z",
    transform: "translate(0 -295.296)",
    fill: "#3d73ec"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy1);
export default __webpack_public_path__ + "static/media/why1.a036a66be33b8967f85d5132eff728d5.svg";
export { ForwardRef as ReactComponent };